<template>
  <div class="modal fade" id="createDocumentModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Create Document</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="createDocument" enctype="multipart/form-data">
            <div class="form-group">
              <label for="title">Title</label>
              <input type="text" class="form-control" id="title" v-model="document.title" required>
            </div>
            <div class="form-group">
              <label for="description">Description</label>
              <textarea class="form-control" id="description" v-model="document.description" required></textarea>
            </div>
            <div class="form-group">
              <label for="attachment">Attachment</label>
              <input type="file" class="form-control-file" id="attachment" @change="handleFileUpload" required>
            </div>
            <button type="submit" class="btn btn-primary">Save</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      document: {
        title: '',
        description: '',
        status: '',
        attachment: null,
      },
    };
  },
  methods: {
    handleFileUpload(event) {
      this.document.attachment = event.target.files[0];
    },

    createDocument() {
      const formData = new FormData();
      formData.append('employee_id', this.$store.getters.getEmployeeProfileId.id);
      formData.append('title', this.document.title);
      formData.append('description', this.document.description);
      formData.append('attachment', this.document.attachment);
      this.$axios({
        method: "POST",
        data:formData,
        url: this.$DocumentStore,
        headers: this.getAuthHeaderForImage(),
      }).then(response => {
        this.$emit('documentCreated');
        $('#createDocumentModal').modal('hide');
        this.document.title = '';
        this.document.description = '';
        this.document.status = '';
        this.document.attachment = null;
      }).catch(error => {
        console.error(error);
      });
    },
  },
};
</script>
